import { useRecoilState } from 'recoil';
import { tempEndContract } from '../../atom/atom';
import { useEffect, useMemo, useState } from 'react';
import { jsPDF } from 'jspdf';
import { getCompanys, getEmployee } from '../../services/dataService';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import Loading from '../../components/common/Loading';

const UID = localStorage.getItem("userId");

function ContractEnd() {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedDaysFilter, setSelectedDaysFilter] = useState('Within30');
  const [companyDetails, setCompanyDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const isAdmin = localStorage.getItem("IsAdmin");
  const departmentIds = localStorage.getItem("DepartmentId") || "";
  const dep = departmentIds.split(",")[0] || null;

  // Safe employee list fetch with error handling
  // const getEmployeeList = async () => {
  //   try {
  //     setLoading(true);
  //     setError(null);
      
  //     if (!UID) {
  //       throw new Error("User ID not found");
  //     }
      
  //     const response = await getEmployee(UID);
      
  //     // Safe response handling
  //     if (!response?.data?.data || !Array.isArray(response.data.data)) {
  //       throw new Error("Invalid response format");
  //     }
      
  //     const datas = isAdmin == 1 
  //       ? response.data.data 
  //       : response.data.data.filter((el) => el?.DepartmentId == dep);
      
  //     // Safe filtering with null checks
  //     const filteredEmployees = datas.filter(employee =>
  //       employee && 
  //       employee.ContractEndDate &&
  //       employee.ContractEndDate !== "" &&
  //       employee.ContractEndDate !== null &&
  //       employee.ContractEndDate !== "null" &&
  //       employee.ContractEndDate !== "undefined"
  //     );
      
  //     setData(filteredEmployees || []);
  //   } catch (error) {
  //     console.error("Error fetching employee data:", error);
  //     setError(error.message || 'Failed to fetch employee data');
  //     toast.error('Failed to fetch employee data');
  //     setData([]); // Ensure data is always an array
  //   } finally {
  //     setLoading(false);
  //   }
  // };

 

  const fetchEmployee = async () => {
  try {
    const UserId=localStorage.getItem("userId");
    const response = await getEmployee(UserId);

    const datas = isAdmin == 1
      ? response.data.data
      : response.data.data.filter((el) => el?.DepartmentId == dep);

    // Safe filtering with simplified null/empty check
    const filteredEmployees = (datas || []).filter(
      (employee) => employee?.ContractEndDate && 
                    employee.ContractEndDate !== "null" &&
                    employee.ContractEndDate !== "undefined"
    );

    setData(filteredEmployees);
  } catch (error) {
    console.error("Error fetching employees:", error);
    setData([]); // fallback to empty
  }
};
   useEffect(() => {
    fetchEmployee();
  }, [UID]);
  // Safe departments calculation
  const departments = useMemo(() => {
    try {
      if (!Array.isArray(data) || data.length === 0) return [];
      
      const departmentNames = data
        .map(emp => emp?.DepartmentName)
        .filter(name => name && typeof name === 'string')
        .filter(Boolean); // Remove falsy values
      
      return [...new Set(departmentNames)].sort();
    } catch (error) {
      console.error("Error calculating departments:", error);
      return [];
    }
  }, [data]);

  // Safe date calculation with validation
  const getDaysUntilContractEnd = (contractEndDate) => {
    try {
      if (!contractEndDate || contractEndDate === 'null' || contractEndDate === 'undefined') {
        return null;
      }
      
      const today = new Date();
      const endDate = new Date(contractEndDate);
      
      // Check for invalid date
      if (isNaN(endDate.getTime())) {
        console.warn("Invalid date:", contractEndDate);
        return null;
      }
      
      const diffTime = endDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      return diffDays;
    } catch (error) {
      console.error("Error calculating days until contract end:", error);
      return null;
    }
  };

  // Safe data filtering
  const filteredData = useMemo(() => {
    try {
      if (!Array.isArray(data) || data.length === 0) return [];

      let filtered = data.filter(employee => {
        if (!employee) return false;
        
        // Safe search matching
        const matchesSearch = !searchTerm || (
          (employee.Name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
          (employee.Code?.toString() || '').includes(searchTerm) ||
          (employee.DesignationName?.toLowerCase() || '').includes(searchTerm.toLowerCase())
        );

        const matchesDepartment = !selectedDepartment || 
          employee.DepartmentName === selectedDepartment;

        // Safe days filter logic
        let matchesDaysFilter = true;
        if (selectedDaysFilter !== 'default') {
          const daysUntilEnd = getDaysUntilContractEnd(employee.ContractEndDate);
          
          if (daysUntilEnd === null) {
            matchesDaysFilter = false;
          } else {
            switch (selectedDaysFilter) {
              case 'Within30':
                matchesDaysFilter = daysUntilEnd <= 30 && daysUntilEnd >= 0;
                break;
              case 'after30':
                matchesDaysFilter = daysUntilEnd > 30;
                break;
              case 'after60':
                matchesDaysFilter = daysUntilEnd > 60;
                break;
              case 'after90':
                matchesDaysFilter = daysUntilEnd > 90;
                break;
              default:
                matchesDaysFilter = true;
            }
          }
        }

        return matchesSearch && matchesDepartment && matchesDaysFilter;
      });

      // Safe sorting
      if (selectedDaysFilter === 'default' && !selectedDepartment) {
        filtered = filtered.sort((a, b) => {
          const deptA = a?.DepartmentName || '';
          const deptB = b?.DepartmentName || '';
          const nameA = a?.Name || '';
          const nameB = b?.Name || '';
          
          if (deptA !== deptB) {
            return deptA.localeCompare(deptB);
          }
          return nameA.localeCompare(nameB);
        });
      }

      return filtered;
    } catch (error) {
      console.error("Error filtering data:", error);
      return [];
    }
  }, [data, searchTerm, selectedDepartment, selectedDaysFilter]);

  const fetchCompanyDetails = async () => {
  try {
    const UserId=localStorage.getItem("userId");

    const response = await getCompanys(UserId);

    setCompanyDetails(response?.data?.data?.[0] || {});
  } catch (error) {
    console.error("An error occurred:", error);
    toast.error("An error occurred while fetching company details");
    setCompanyDetails({}); // Fallback to empty object
  }
};

useEffect(() => {
  fetchCompanyDetails();
}, []); // change to [] if UID never changes

  // Safe date formatting
  const formatDate = (dateString) => {
    try {
      if (!dateString || dateString === 'null' || dateString === 'undefined') {
        return 'N/A';
      }
      
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }
      
      return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return 'N/A';
    }
  };

  // Safe report title generation
  const generateReportTitle = () => {
    try {
      const companyName = companyDetails?.Name || 'Company';
      let title = `${companyName} Contract End Report`;

      if (selectedDepartment) {
        title += ` - ${selectedDepartment} Department`;
      }

      switch (selectedDaysFilter) {
        case 'Within30':
          title += ` - Ending Within 30 days`;
          break;
        case 'after30':
          title += ` - Ending after 30 days`;
          break;
        case 'after60':
          title += ` - Ending after 60 days`;
          break;
        case 'after90':
          title += ` - Ending after 90 days`;
          break;
      }

      return title;
    } catch (error) {
      console.error("Error generating report title:", error);
      return 'Contract End Report';
    }
  };

  // Safe PDF export with error handling
  const exportToPDF = (companyDetails = {}) => {
    try {
      if (!Array.isArray(filteredData) || filteredData.length === 0) {
        toast.error('No data available to export');
        return;
      }

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      });

      // Safe PDF generation
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      const reportTitle = `${companyDetails?.Name || 'Company'} Contract End Report`;
      doc.text(reportTitle, 148.5, 15, { align: 'center' });

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 148.5, 22, { align: 'center' });

      const headers = ['SN', 'Name', 'Code', 'Designation', 'Department', 'End Date', 'Days Left'];
      const columnWidths = [15, 45, 30, 45, 60, 35, 30];
      const tableWidth = columnWidths.reduce((sum, width) => sum + width, 0);
      const startX = (297 - tableWidth) / 2;
      let y = 30;

      // Draw table header
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.setDrawColor(0, 0, 0);
      doc.setFillColor(255, 255, 255);
      doc.rect(startX, y, tableWidth, 8, 'F');
      
      let x = startX;
      headers.forEach((header, index) => {
        doc.text(header || '', x + 2, y + 6, { maxWidth: columnWidths[index] - 4 });
        x += columnWidths[index];
      });

      x = startX;
      columnWidths.forEach((width) => {
        doc.rect(x, y, width, 8);
        x += width;
      });

      y += 8;

      // Add table rows with safe data access
      filteredData.forEach((employee, index) => {
        if (!employee) return;
        
        const daysLeft = getDaysUntilContractEnd(employee.ContractEndDate);
        const row = [
          (index + 1).toString(),
          employee.Name || 'N/A',
          employee.Code?.toString() || 'N/A',
          employee.DesignationName || 'N/A',
          employee.DepartmentName || 'N/A',
          formatDate(employee.ContractEndDate),
          daysLeft !== null ? daysLeft.toString() : 'N/A'
        ];

        x = startX;
        row.forEach((cell, i) => {
          const cellText = cell?.toString() || '';
          const textLines = doc.splitTextToSize(cellText, columnWidths[i] - 4);
          doc.text(textLines, x + 2, y + 4, { maxWidth: columnWidths[i] - 4 });
          doc.rect(x, y, columnWidths[i], 8);
          x += columnWidths[i];
        });

        y += 8;

        if (y > 190) {
          doc.addPage();
          y = 20;
          
          // Redraw header on new page
          doc.rect(startX, y, tableWidth, 8, 'F');
          x = startX;
          headers.forEach((header, index) => {
            doc.text(header || '', x + 2, y + 6, { maxWidth: columnWidths[index] - 4 });
            x += columnWidths[index];
          });

          x = startX;
          columnWidths.forEach((width) => {
            doc.rect(x, y, width, 8);
            x += width;
          });

          y += 8;
        }
      });

      doc.save('Contract_End_Report.pdf');
      toast.success('PDF exported successfully');
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error('Failed to export PDF');
    }
  };

  // Loading state
  if (loading) {
    return <Loading />;
  }

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <div className="max-w-full mx-auto bg-white shadow rounded-lg">
        {/* Header */}
        <div className="px-4 py-5 border-b border-gray-200">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div>
              <h1 className="text-xl font-semibold text-gray-900">
                {generateReportTitle()}
              </h1>
              <p className="text-sm text-gray-500">
                {selectedDaysFilter === 'default'
                  ? 'All employees with contract end dates (grouped by department)'
                  : selectedDaysFilter === 'Within30'
                    ? 'Employees with contracts ending Within 30 days'
                    : selectedDaysFilter === 'after30'
                      ? 'Employees with contracts ending after 30 days'
                      : selectedDaysFilter === 'after60'
                        ? 'Employees with contracts ending after 60 days'
                        : 'Employees with contracts ending after 90 days'
                }
              </p>
            </div>
            <div className="flex justify-end space-x-4 mt-4">
              <button
                className="btn btn-primary"
                onClick={() => exportToPDF(companyDetails)}
                disabled={!Array.isArray(filteredData) || filteredData.length === 0}
              >
                Download PDF
              </button>
              <Link to={'/'}>
                <button className="btn btn-danger">
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="px-4 py-4 border-b border-gray-200">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="Search by name, code, or designation..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value || '')}
              className="px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 w-[300px]"
            />
            {isAdmin == 1 && (
              <select
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value || '')}
                className="px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 w-[300px]"
              >
                <option value="">All Departments</option>
                {departments.map(dept => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
            )}
            <select
              value={selectedDaysFilter}
              onChange={(e) => setSelectedDaysFilter(e.target.value || 'Within30')}
              className="px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 w-[300px]"
            >
              <option value="Within30">Within 30 days</option>
              <option value="after30">After 30 days</option>
              <option value="after60">After 60 days</option>
              <option value="after90">After 90 days</option>
              <option value="default">Default</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SN</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Code</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Designation</th>
                {isAdmin == 1 && (
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Department</th>
                )}
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">End Date</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Days Left</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {(() => {
                if (selectedDaysFilter === 'default' && !selectedDepartment) {
                  let serialNumber = 1;

                  return filteredData.map((employee) => {
                    if (!employee) return null;
                    
                    const daysLeft = getDaysUntilContractEnd(employee.ContractEndDate);
                    const isUrgent = daysLeft !== null && daysLeft <= 7 && daysLeft >= 0;
                    const isExpired = daysLeft !== null && daysLeft < 0;

                    return (
                      <tr key={employee.Id || serialNumber} className="hover:bg-gray-50">
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">{serialNumber++}</td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{employee.Name || 'N/A'}</td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.Code || 'N/A'}</td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.DesignationName || 'N/A'}</td>
                        {isAdmin == 1 && (
                          <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.DepartmentName || 'N/A'}</td>
                        )}
                        <td className={`px-4 py-4 whitespace-nowrap text-sm ${isExpired ? 'text-red-600 font-bold' : 'text-red-600'}`}>
                          {formatDate(employee.ContractEndDate)}
                        </td>
                        <td className={`px-4 py-4 whitespace-nowrap text-sm font-medium ${isExpired ? 'text-red-600' : isUrgent ? 'text-orange-600' : 'text-gray-600'}`}>
                          {daysLeft !== null ? (
                            isExpired ? `Expired ${Math.abs(daysLeft)} days ago` : `${daysLeft} days`
                          ) : 'N/A'}
                        </td>
                      </tr>
                    );
                  }).filter(Boolean); // Remove null entries
                } else {
                  return filteredData.map((employee, index) => {
                    if (!employee) return null;
                    
                    const daysLeft = getDaysUntilContractEnd(employee.ContractEndDate);
                    const isUrgent = daysLeft !== null && daysLeft <= 7 && daysLeft >= 0;
                    const isExpired = daysLeft !== null && daysLeft < 0;

                    return (
                      <tr key={employee.Id || index} className="hover:bg-gray-50">
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">{index + 1}</td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{employee.Name || 'N/A'}</td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.Code || 'N/A'}</td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.DesignationName || 'N/A'}</td>
                        {isAdmin == 1 && (
                          <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.DepartmentName || 'N/A'}</td>
                        )}
                        <td className={`px-4 py-4 whitespace-nowrap text-sm ${isExpired ? 'text-red-600 font-bold' : 'text-red-600'}`}>
                          {formatDate(employee.ContractEndDate)}
                        </td>
                        <td className={`px-4 py-4 whitespace-nowrap text-sm font-medium ${isExpired ? 'text-red-600' : isUrgent ? 'text-orange-600' : 'text-gray-600'}`}>
                          {daysLeft !== null ? (
                            isExpired ? `Expired ${Math.abs(daysLeft)} days ago` : `${daysLeft} days`
                          ) : 'N/A'}
                        </td>
                      </tr>
                    );
                  }).filter(Boolean); // Remove null entries
                }
              })()}
            </tbody>
          </table>
          {(!Array.isArray(filteredData) || filteredData.length === 0) && (
            <div className="p-8 text-center">
              <p className="text-gray-500">No employees match your search criteria</p>
              <p className="text-sm text-gray-400 mt-1">Try adjusting your search or filters</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContractEnd;